/* Global - Quantity input function */
/* -------------------------------------------------------------------------------------- */
function debounce(func, wait, immediate) {
	var timeout;
	return function() {
		var context = this, args = arguments;
		var later = function() {
			timeout = null;
			if (!immediate) func.apply(context, args);
		};
		var callNow = immediate && !timeout;
		clearTimeout(timeout);
		timeout = setTimeout(later, wait);
		if (callNow) func.apply(context, args);
	};
};

function onProductClick(elemento){
	var product = $(elemento);
	var dataLayerTitle = product.attr('data-title');
	var dataLayerPrice = product.attr('data-price');
	var dataLayerID = product.attr('data-id');
	var dataLayerVendor = product.attr('data-vendor');
	var dataLayerType = product.attr('data-type');
	var dataLayerCollection = product.attr('data-collection');
	var dataLayerType = product.attr('data-type');
	var dataLayerVariant = product.attr('data-variant');
	window.dataLayer = window.dataLayer || []; 
	window.dataLayer.push({
		'event': "select_item",
		'ecommerce': {
			"items": [{
				"item_name": `${dataLayerTitle}`,
				"item_id": `${dataLayerID}`,
				"price": `${dataLayerPrice}`,
				"item_brand": `${dataLayerVendor}`,
				'item_category': `${dataLayerType}`,
				'item_category2': '',
				'item_category3': '',
				'item_category4': '',
				'item_variant': '',
				'item_variant2': '',
				'item_list_name': `${dataLayerCollection}`,
				'item_list_id': '',
				'quantity': '1',
				'index': '',	  
			}]
		}
	});
}

document.addEventListener('DOMContentLoaded', () => {
	/* Menu - Open/Close */
	/* -------------------------------------------------------------------------------------- */
	$('.js-open-menu').on('click', function(event) {
		event.preventDefault();
		/* Act on the event */
		var el = $(this),
			item = $(el.attr('data-open'));
		el.addClass('active');
		item.addClass('active');
		$("[data-close='#menu-izquierdo']").addClass('active');
	});

	$('.js-close-menu').on('click', function(event) {
		event.preventDefault();
		/* Act on the event */
		var el = $(this),
			item = $(el.attr('data-close'));
		el.removeClass('active');
		item.removeClass('active');
		$("[data-open='#menu-izquierdo']").removeClass('active');
	});
	/* Open/Close */
	/* -------------------------------------------------------------------------------------- */
	$('body').on('click', '[js-open-item]', function(event) {
		event.preventDefault();
		/* Act on the event */
		var el = $(this),
			item = $(el.attr('data-open'));
		item.addClass('active');
	});

	$('body').on('click', '[js-close-item]', function(event) {
		event.preventDefault();
		/* Act on the event */
		var el = $(this),
			item = $(el.attr('data-close'));
		item.removeClass('active');
	});

	$('body').on('click', '[js-toggle-item]', function(event) {
		event.preventDefault();
		/* Act on the event */
		var el = $(this),
			item = $(el.attr('data-toggle'));
		item.toggleClass('active');
		el.toggleClass('active');
	});
	/* Change Image - Click variant */
	/* -------------------------------------------------------------------------------------- */
	$('body').on('click', '[js-product-card-variant-item]', function(event) {
		event.preventDefault();
		/* Act on the event */
		console.log('Entra');
		var el = $(this);
		var newImage = el.attr('data-background');
		var contentImage = el.closest('.js-item-products').find('.js-product-card-feature-image');
		contentImage.attr('src', newImage);
		contentImage.attr('srcset', newImage);
		el.addClass('active').siblings('[js-product-card-variant-item]').removeClass('active');
	});
	/* DATALAYER - Click product card */
	/* -------------------------------------------------------------------------------------- */
	// $('body').on('click', '.js-item-products', function(event) {
	// 	event.stopPropagation();
	// 	/* Act on the event */
	// 	var productCard = $(this);
	// 	onProductClick(productCard);
	// });
});